module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_35",
      "title": "35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNKNOWN LOCATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("The girl tried to open her eyes. The tang of metal filled her mouth. The sound of the kitten mewling was all she could hear.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("One of her eyes finally cracked open.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The thick smoke was long gone and the monster hadn’t been back in so long that thirst constricted her throat. Made it hard to think about anything but water. Water flowing across her cracked lips, wetting her dry mouth, filling her sour stomach. Her body ached and craved and shuddered, like it was collapsing from the inside out.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("At least there were no more nightmare pictures. Gaping monsters and fanged cats clawing at her flesh. They felt so real.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But now the monster was gone. Called her a failure, left her to die of thirst in this cage.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The other eye opened and she leaned forward to cry, though no tears fell.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In the darkness all she felt was the weakening heartbeat of the kitten under her fingers. Bast hadn’t had food or water either. She would die first. Bast’s dry sandpaper tongue licked her peeling skin as she gratefully faded away.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7ed5e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter9.vue
// module id = 93
// module chunks = 0